import React, { useState } from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import MinusIcon from '@wix/da-ds/pkg/Icons/24x24/Minus';
import s from './Faqs.scss';
const FaqItem = ({ faq })=>{
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper'],
        key: faq.title
    }, /*#__PURE__*/ React.createElement("h3", {
        className: s['question'],
        onClick: ()=>setIsOpen(!isOpen)
    }, faq.title, ' ', isOpen ? /*#__PURE__*/ React.createElement(MinusIcon, {
        size: IconSize.MEDIUM
    }) : /*#__PURE__*/ React.createElement(AddIcon, {
        size: IconSize.MEDIUM
    })), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['answer'], isOpen && s['open']),
        dangerouslySetInnerHTML: {
            __html: faq.body
        }
    }));
};
const Faqs = ({ faqs })=>{
    if (!faqs || faqs.length === 0) {
        return null;
    }
    return faqs.map((faq, index)=>/*#__PURE__*/ React.createElement(FaqItem, {
            key: index,
            faq: faq
        }));
};
Faqs.displayName = 'Faqs';
export default Faqs;

//# sourceMappingURL=Faqs.js.map